import { render, staticRenderFns } from "./GeneFamilyTool.vue?vue&type=template&id=050116de&scoped=true"
import script from "./GeneFamilyTool.vue?vue&type=script&lang=js"
export * from "./GeneFamilyTool.vue?vue&type=script&lang=js"
import style0 from "./GeneFamilyTool.vue?vue&type=style&index=0&id=050116de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050116de",
  null
  
)

export default component.exports